module.exports = __webpack_public_path__ + "img/login4.394f9b2e.jpg";